const pixelsCategories = ["PERFORMANCE","STRICTLY_NECESSARY"];

export { pixelsCategories };